import type { Site } from '../Site';

export const GoCompare: Site = {
  id: 'gocompare',
  analyticsName: 'gocompare',
  selector: '',
  logo: '',
  label: 'Go.Compare',
  platform: '',
};
